import dayjs from 'dayjs';
import { GridColDef } from '@mui/x-data-grid';
import { DATE_FORMAT, LINK_STATUS_CONTENT, SOURCE_STATUS_NAME } from '@constants';
import { SourceType } from '@services';
import { Box, Chip, Typography } from '@mui/material';
import { LinkPreview } from '@atoms';
import { RenderLinkCell } from '@molecules/Table/cells';

export const getColumns = (filterText?: string): GridColDef[] => [
  {
    field: 'url',
    headerName: 'Link',
    width: 350,
    flex: 1,
    renderCell: ({ value }) => <RenderLinkCell filterText={filterText} idList="" value={value} />,
  },
  {
    field: 'url',
    width: 50,
    headerName: '',
    sortable: false,
    renderCell: ({ value }) => <LinkPreview src={value} />,
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 180,
    renderCell: ({ value }) => {
      const statusProps = LINK_STATUS_CONTENT[value];

      return <Chip label={statusProps?.label} color={statusProps?.color} variant="filled" />;
    },
  },
  {
    field: 'sourceType',
    headerName: 'Source type',
    width: 200,
    renderCell: ({ value }) => SOURCE_STATUS_NAME[value as SourceType],
  },
  {
    field: 'updatedAt',
    headerName: 'Update date',
    width: 170,
    renderCell: ({ value }) => (
      <Box>
        <span>
          <Typography fontSize={10}>Update date</Typography>
          {value ? dayjs(value).format(DATE_FORMAT) : 'N/A'}
        </span>
      </Box>
    ),
  },
  {
    field: 'createdAt',
    headerName: 'Date of addition',
    width: 170,
    renderCell: ({ value }) => (
      <Box>
        <span>
          <Typography fontSize={10}>Date of addition</Typography>
          {value ? dayjs(value).format(DATE_FORMAT) : 'N/A'}
        </span>
      </Box>
    ),
  },
];
